export default __webpack_public_path__ + "static/media/tip17.6df6d0a7.png";